export const CONTACT = {
  SUPPORT_EMAIL: "support@pulse-date.com",
} as const;

export const ERROR_MESSAGES = {
  PERSISTENT: `Please try again. If it persists contact ${CONTACT.SUPPORT_EMAIL}`,
};
